import type { ApolloCache, Reference, StoreObject } from '@apollo/client'
import type { ModifierDetails } from '@apollo/client/cache'

// Inside `cache.modify` the edge node is a store reference, not the entity.
type DraftsCacheEdge = { node: Reference | StoreObject }

/**
 * Removes a deleted post or content item from every cached `drafts` list, so
 * the Drafts tab drops it without a refetch.
 */
export function removeDraftFromDraftsLists(
  cache: ApolloCache,
  draftId: string,
): void {
  cache.modify({
    fields: {
      drafts(
        existingConnection: Reference | StoreObject,
        { readField }: ModifierDetails,
      ) {
        if (existingConnection && '__ref' in existingConnection) {
          return existingConnection
        }

        const edges =
          readField<DraftsCacheEdge[]>('edges', existingConnection) ?? []
        const remainingEdges = edges.filter(
          (edge) => readField('id', edge.node) !== draftId,
        )
        if (remainingEdges.length === edges.length) {
          return existingConnection
        }

        return { ...existingConnection, edges: remainingEdges }
      },
    },
  })
}
